var LOCALE = window.LOCALE || {};
LOCALE.en = {
    ERROR: 'Oops!',
    ERROR_UNDEFINED: 'Undefined error',
    ERROR_APP: 'Something went wrong. Please refresh the page to continue. We are sorry for the inconvenience. Contact our Support if this error persists.',
    ERROR_REQUIRED_FP_VER: 'To continue, you must enable Adobe Flash Player on this page.\nThe game doesn\'t support versions less than Flash Player ',
    ACTION_UPDATE_FP: 'Allow',
    PLEASE_RELOAD: 'Please refresh the page',
    ACTION_RELOAD: 'Refresh',
    GAME: 'Play',
    SUPPORT: 'Support',
    COMMUNITY: 'Community',
    YOUR_ID: 'Your ID',
    LOADING: 'Loading',
    GAME_NAME: 'Lords of the Arena',
    ERROR_SOCIAL: 'Social network error',
    LIKE_BUTTON_TITLE: 'Lords of the Arena',
    LIKE_BUTTON_DESCRIPTION: 'Lords of the Arena game',
    FAQ: 'FAQ',
    ACTION_INVITE: 'Invite',
    SIG_SERVER_22: 'The game is temporarily unavailable due to server maintenance. Please try again later.',
    INVITE_MESSAGE: 'Fight with me in this new strategy game. Great battles await us!',
    INVITE_TITLE: 'Lords of the Arena!',
    FP_DIALOG_MESSAGE1: 'To start the game you need to launch Flash player',
    FP_DIALOG_ENABLE1: 'If the window does not appear, open that link in a new tab:',
    FP_DIALOG_ENABLE2: 'chrome://settings/content/flash',
    FP_DIALOG_ENABLE3: 'Disable "Prevent sites from running Flash" setting, then return to game and click "Launch!" button once again.',
    FP_DIALOG_RUN: 'Launch!',
    FP_DIALOG_ALLOW: 'A new dialog window should appear. Click "Allow".',
    REGISTER_DIALOG_MESSAGE: 'Please sign in to Kongregate to play this game',
    REGISTER_DIALOG_RUN: 'Sign in now',
    RELOAD_AFTER_LOGIN: 'Thanks for signing in!\nPlease refresh the page to play.',
    SWF_PLAYER_FALLBACK_NOTICE: 'If you have problems loading the game, you can use the "Switch to Flash" option in the top menu.',
    SWITCH_TO_SWF_PLAYER: 'Switch to Flash',
    SWITCH_TO_HTML_PLAYER: 'Switch to HTML',
    MESSAGE_AUTH_REQUIRED: 'Authorization is required to continue game and save progress.',
    ACTION_AUTHENTICATE: 'Authorize!'
};
